import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['content', 'link']

  toggle() {
    this.contentTarget.classList.toggle('hidden')
    this.linkTarget.classList.toggle('hidden')
  }
}
